export default __webpack_public_path__ + "static/media/federation_icon.e2206025.svg";